
import React from 'react';
export const JacobsIcon = ({ color }) => {
    return (
        <svg width="14" height="22" viewBox="0 0 29 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.2253 37.9475C22.8526 37.9475 28.7053 31.8885 28.7053 23.4675V19.0001H21.2084V23.4675C21.2084 27.8843 18.4863 30.758 14.2253 30.758C10.2211 30.758 7.90948 28.2422 7.49895 24.6991H0.0526352C0.463162 32.4527 6.06106 37.9475 14.2253 37.9475ZM21.2084 14.2759H28.7053V0.0527344H14.0716V7.13905H21.2084V14.2759Z" fill="white" />
        </svg>
    );
};

JacobsIcon.defaultProps = {
    color: 'white',
};
